export default "__VITE_ASSET__026437d3__"